<sp-broadcast
  level="<%= slot_message.level %>"
  icon="<%= slot_message.icon %>"
  <%= slot_message.collapsable ? "collapsable" : "" %>
  <%= slot_message.dismissable ? "dismissable" : "" %>
  inline
>
  <% if (slot_message.title) { %>
    <span slot="title"><%= slot_message.title %></span>
  <% } %>
  <div class="broadcast-message-text"><%= slot_message.text %></div>
</sp-broadcast>
